import type { TDataExportStoreState } from 'App/data-export/store/dataExportStore'
import { fieldAssetsOptions } from 'App/data-export/store/selectors/fieldAssetsOptions'
import { translate } from 'i18n/i18n'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'

export const validatePropertyIdAndFieldAssetIds = (
  s: TDataExportStoreState,
): {
  propertyId: TDataExportStoreState['formErrors']['propertyId']
  fieldAssetIds: TDataExportStoreState['formErrors']['fieldAssetIds']
} => {
  // Is it valid?
  const atLeastOneAssetIsSelected =
    s.formState.blockIds.length + s.formState.points.length + s.formState.irrigationZoneEmitterIds.length > 0

  if (s.formState.propertyId !== null && atLeastOneAssetIsSelected) {
    return {
      propertyId: null,
      fieldAssetIds: null,
    }
  }

  // If we made it here, it's not valid...
  const { blocksOptions, pointsOptions, irrigationZoneEmittersOptions } = fieldAssetsOptions({
    propertyId: s.formState.propertyId,
    fieldAssetStoreState: fieldAssetStore.getState(),
  })

  const someOptionsAreAvailable =
    blocksOptions.length > 0 || pointsOptions.length > 0 || irrigationZoneEmittersOptions.length > 0

  return {
    propertyId:
      s.formState.propertyId === null ? translate.phrases.banyanApp('Please select a property') : null,
    fieldAssetIds:
      someOptionsAreAvailable && !atLeastOneAssetIsSelected
        ? translate.phrases.banyanApp('Please select at least one data source')
        : null,
  }
}
